import { FC } from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router';

import loadableRoutes from './loadableRoutes';
import { ConnectedSwitch } from './reactRouterConnected';
import { PROPERTIES_PAGE_LINK } from '../commons/constants';
import NotFoundPage from '../pages/NotFoundPage';
import useAuth from '../hooks/useAuth';

const WrapperComponent = ({ component: Component, ...props }) => {
  useAuth({ requiredAuth: props.requiredAuth });
  return <Component {...props} />;
};

const WrapperNotFoundComponent = () => {
  useAuth();
  return <NotFoundPage />;
};

const Routes: FC = () => (
  <ConnectedSwitch>
    <Route exact path="/">
      <Redirect to={PROPERTIES_PAGE_LINK} />
    </Route>
    {Object.keys(loadableRoutes).map((path) => {
      const routeProps = loadableRoutes[path];

      return (
        <Route
          key={path}
          path={path}
          component={(props) => <WrapperComponent {...routeProps} {...props} />}
        />
      );
    })}
    <Route
      render={() => {
        return <WrapperNotFoundComponent />;
      }}
    />
  </ConnectedSwitch>
);

export { loadableRoutes };
export default Routes;
